<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("code") }}</label>
                  <b-form-input
                    :placeholder="$t('code')"
                    v-model="ProductCategory.code"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("shortname") }}</label>
                  <b-form-input
                    v-model="ProductCategory.shortname"
                    :placeholder="$t('shortname')"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("fullname") }}</label>
                  <b-form-input
                    v-model="ProductCategory.fullname"
                    :placeholder="$t('fullname')"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="mt-2">
                  <label for>{{ $t("state") }}</label>
                  <div>
                    <v-select
                      :options="StateList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="ProductCategory.stateid"
                    ></v-select>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-left">
                <b-button
                  @click="$router.push('/info/productcategory')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import ProductCategoryService from "@/services/info/productcategory.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
export default {
  components: { Multiselect, Layout, PageHeader, vSelect },
  data() {
    return {
      title: this.$t("ProductCategory"),
      braedcrumb: [
        {
          text: this.$t("Info"),
        },
        {
          text: this.$t("ProductCategory"),
          active: true,
        },
      ],
      items: [],
      //   show: false,
      ProductCategory: {},
      filter: {},
      StateList: [],
      lang: "ru",
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetStateList().then((res) => {
      this.StateList = res.data;
    });
    ProductCategoryService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.ProductCategory = res.data;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    SaveData() {
      ProductCategoryService.Update(this.ProductCategory)
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `productcategory` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style></style>
